import React from "react";
import {useTranslation} from "react-i18next";

export function ErrorMessage() {
  const {t} = useTranslation();
  return <div className="error-message">{t('Error')}</div>
}